import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Loader = () => {
    return <div data-testid="loader" className='loader'><FontAwesomeIcon spin={true} icon={faSpinner} /> Loading...</div>
}
